var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('a-page-header',{staticStyle:{"border":"1px solid rgb(235, 237, 240)","background":"#ffffff"},attrs:{"title":_vm.title,"breadcrumb":{ props: { routes: _vm.routes } },"sub-title":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }